import HeroImage from "@/components/HeroImage";
import PageHeading from "@/components/PageHeading";
import { ContentPage as ContentPageType } from "graphql/generated-types";
import React from "react";
import BlockRouter, { BlockTypes } from "@/components/blocks/BlockRouter";

const ContentPage = ({ data }: { data: ContentPageType }) => {
	return (
		<>
			<div className="container grid-cols-3 lg:grid">
				<PageHeading title={data.title} subtitle={data.subtitle} />
			</div>

			{data.heroImage && (
				<HeroImage
					src={data.heroImage?.rendition?.url || ""}
					alt={data.heroImage?.rendition?.image?.title!}
					caption={data?.heroCaption}
				/>
			)}
			{data.body?.map((block, i) => {
				return <BlockRouter block={block as BlockTypes} key={i} />;
			})}
		</>
	);
};

export default ContentPage;
